import type { IErrorQuote } from '@/shared/common/types/quoteError.type';

export const ErrorsQuote: IErrorQuote = {
  ROUTE_NOT_FOUND: 'Ruta no encontrada.',
  ROUTE_PAIR_NOT_FOUND: 'Ruta no encontrada.',
  CURRENCY_NOT_FOUND: 'Error: Moneda de la ruta no encontrada.',
  PAYMENT_TYPE_NOT_FOUND: 'Error: Método de pago no encontrado.',
  CUSTOMER_TYPE_NOT_VALID: 'Error: Tipo de cliente inválido.',
  TAX_TYPE_NOT_FOUND: 'Error: Tipo de impuesto no encontrado.',
  PAYLOAD_CANNOT_BE_ENCRYPT: 'Error interno del servidor. Intenta nuevamente más tarde.',
  QUOTE_GENERIC_ERROR: 'Error al generar la cotización. Intenta nuevamente.',
} as const;
